import { getAnonId } from '@/utils/anonId';
import { USE_DEFAULT } from '@/utils/configValues';
import { validateEnv } from '@/utils/validateEnv';
import { initFlagsmith as initFlagsmithBase } from '@resolve_medical_bills/flagsmith/react';
import * as Sentry from '@sentry/browser';
import { FALLBACK_FLAGS } from './fallback';

/**
 * Starts Flagsmith for this visitor.
 *
 * `defaultFlags` is what every flag reads until Flagsmith answers, and what it
 * keeps reading when Flagsmith cannot be reached, so an outage leaves each flag
 * at its safe default. A failed fetch is reported to Sentry so an outage is
 * visible. With `VITE_FLAGSMITH_TOKEN=USE_DEFAULT` (laptops, tests) Flagsmith
 * is not started at all and the defaults apply.
 */
export const initFlagsmith = async (): Promise<void> => {
  const environmentID = validateEnv().VITE_FLAGSMITH_TOKEN;
  const options = {
    identity: getAnonId(),
    cacheFlags: true,
    defaultFlags: FALLBACK_FLAGS,
  };
  if (environmentID === USE_DEFAULT) {
    await initFlagsmithBase({
      ...options,
      environmentID,
      preventFetch: true,
      enableAnalytics: false,
    });
    return;
  }
  await initFlagsmithBase({
    ...options,
    environmentID,
    enableAnalytics: true,
    onError: (error) => Sentry.captureException(error),
  });
};
